import { makeAutoObservable } from 'mobx';
import { StepperStore } from '../../shared/util-stores';
import { resetAllStore } from '../../shared/stores/resetAllStore';
import { EntityType } from '../../shared/constants/user-info/ENTITY_TYPES';
import { BillingType } from '../../shared/constants/user-info/billingType';
import {
  SolutionTypeFlags,
  SOLUTION_TYPE,
  SolutionType,
} from '../../shared/constants/user-info/solutionType';
import { getFlagsObject } from '../../shared/utils/sortingAndGroupingUtil';

class SetupEntityStore {
  stepperMethods: StepperStore;
  entityId: number | null = null;
  entityType: EntityType | null = null;
  billingType: BillingType | null = null;
  solutions: SolutionType[] = [];
  solutionTypeFlags: SolutionTypeFlags = {};

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
    this.stepperMethods = new StepperStore();
  }

  setDefaultValues() {
    this.stepperMethods.setDefaultValues();
    this.entityId = null;
    this.entityType = null;
    this.billingType = null;
  }

  setEntityId(entityId: number) {
    this.entityId = entityId;
  }

  setEntityType(entityType: EntityType) {
    this.entityType = entityType;
  }

  setBillingType(billingType: BillingType) {
    this.billingType = billingType;
  }

  setSolutionsInfo(solutions: SolutionType[]) {
    this.setSolutions(solutions);
    this.setSolutionTypeFlags(solutions);
  }

  private setSolutions(solutions: SolutionType[]) {
    this.solutions = solutions;
  }

  private setSolutionTypeFlags(solutions: SolutionType[]) {
    this.solutionTypeFlags = getFlagsObject(SOLUTION_TYPE, solutions);
  }
}

const setupEntityStore = new SetupEntityStore();

resetAllStore.addResetMethod(setupEntityStore.setDefaultValues);

export { setupEntityStore, SetupEntityStore };
